import {
  Navigation, Virtual, Keyboard, FreeMode, Thumbs, Mousewheel, Pagination
} from "swiper/modules"
import {Swiper, SwiperSlide} from "swiper/react"
import FullscreenLayer, {fullscreen_layer_id} from "./fullscreen_layer"
import {use_preload_image} from "./hooks"
import React, {useState} from "react"
import class_names from "classnames"
import PerspectiveIcon from "./perspective_icon"
import FaIcon from "components/fa_icon"
import Portal from "./portal"

import "swiper/css"
import "swiper/css/virtual"
import "swiper/css/navigation"
import "swiper/css/free-mode"
import "swiper/css/pagination"
import "swiper/css/thumbs"

const FullscreenGallery = ({images, current_index, on_close}) => (
  <FullscreenLayer on_close={on_close}>
    <>
      {images.length === 1 && <SingleImage image={images[0]} />}
      {images.length > 1 &&
        <ImageGallery {...{images, current_index}}/>}
    </>
  </FullscreenLayer>
)

export function FullscreenGalleryPortal(props) {
  return (
    <Portal id={fullscreen_layer_id}>
      <FullscreenGallery {...props} />
    </Portal>
  )
}

const SingleImage = ({image}) => {
  const url = use_preload_image(image.fullscreen_url)
  return (
    <div className="fullscreen-single-image">
      {image.fullscreen_info}
      <img className="image__placeholder" src={image.image_url} />
      <img
        className={class_names("image__hd", {loaded: !!url})}
        src={url || image.fullscreen_url}
      />
    </div>
  )
}

const ImageGallery = ({images, current_index}) => {
  current_index = current_index || 0
  const [swiper, set_swiper] = useState(null)
  const [current_image_index, set_current_image_index] = useState(current_index)
  const [thumbs_swiper, set_thumbs_swiper] = useState(null)
  const [is_open, set_is_open] = useState(false)

  return (
    <div className="fullscreen-gallery">
      <div
        className="image-thumbnails-handle"
        onClick={() => set_is_open(!is_open)}
      >
        <FaIcon name={"fa-th-list"}/>
      </div>
      <div className={`image-thumbnails${is_open ? " open" : ""}`}>
        <Swiper
          freeMode
          mousewheel
          spaceBetween={0}
          watchSlidesProgress
          slidesPerView="auto"
          direction="vertical"
          onSwiper={set_thumbs_swiper}
          modules={[Thumbs, Mousewheel, FreeMode]}
        >
          {images.map(image => (
            <SwiperSlide key={image.thumb_url}>
              <div className="image">
                <img src={image.thumb_url} />
              </div>
              {image.fullscreen_info}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="main-gallery" onClick={() => set_is_open(false)}>
        <Swiper
          rewind
          virtual
          keyboard
          mousewheel
          navigation
          pagination={{
            // we assume that if the first image doesn't have a term info none
            // of them has
            enabled: !images[0].fullscreen_info
          }}
          slidesPerView={1}
          onSwiper={set_swiper}
          initialSlide={current_index}
          onSlideChange={() => {
            set_is_open(false)
            if (swiper) set_current_image_index(swiper.activeIndex)
          }}
          thumbs={{
            swiper: thumbs_swiper,
            multipleActiveThumbs: false
          }}
          modules={
            [Virtual, Navigation, Keyboard, Thumbs, Mousewheel, Pagination]
          }
        >
          {images.map(image => (
            <SwiperSlide key={image.fullscreen_url}>
              <ImageSlide image={image} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {!!images[current_image_index].fullscreen_info &&
        <div className="bottom-caption" onClick={() => set_is_open(false)}>
          {images[current_image_index].fullscreen_info}
          <div className="fraction-pagination">
            {current_image_index + 1} / {images.length}
          </div>
        </div>}
    </div>
  )
}

const ImageSlide = ({image}) => {
  const url = use_preload_image(image.fullscreen_url)
  return (
    <>
      {image.image_url &&
        <div
          className="image__placeholder"
          style={{backgroundImage: `url('${image.image_url}')`}}
        >
        </div>}
      <div
        className={class_names("image__hd", {loaded: !!url})}
        style={{backgroundImage: `url('${url || image.fullscreen_url}')`}}
        // used for GI tests
        data-term-image-slug={image.slug}
      >
      </div>
      {image.perspective &&
        <PerspectiveIcon
          perspective={image.perspective}
          tooltip_placement="bottom"
        />}
    </>
  )
}

export default FullscreenGallery
